import { useState } from 'react';
import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import * as Assets from './../../utils/svg_assets';
import * as PageRoutes from '../../utils/route_pages';
import ApiUtils from './../../utils/api_utils';
import { readMore } from '../../utils/utilities';
import ModalZoom from '../ModalZoom';
import './style.scss';

const BannerSlider = (props) => {
  const navigate = useNavigate();
  const organization = useSelector(
    (state) => state.LoginSM.login.organization_structure_label
  );
  const {
    use_icon: useIcon,
    organization_icon: icon,
    name,
  } = organization[0].organization;
  const {
    data,
    isLogo = false,
    isBottom = false,
    isRight = false,
    toPath,
    isVideo = false,
    isHighlight = false,
    isDisplay = false,
  } = props;

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    dotsClass: 'slick-dots center-dots',
  };

  const [isOpen, setIsOpen] = useState(false);
  const [isPlay, setIsPlay] = useState(false);

  const handleRedirect = (data) => {
    if (isVideo) {
      setIsPlay(!isPlay);
    }

    if (isHighlight) {
      if (data.redirect_uri) {
        window.open(data.redirect_uri, '_blank');
      } else {
        navigate(`${PageRoutes.detailNews}/${data.id}`);
      }
    } else {
      if (data.redirect_uri) {
        window.open(data.redirect_uri, '_blank');
      } else {
        setIsOpen(!isOpen);
      }
    }
  };

  return (
    <div className={isDisplay ? 'd-none' : 'wrapper-slider'}>
      <div className="header-logo">
        <div className="top-left">
          {isLogo ? (
            <>
              {useIcon ? (
                <img
                  src={ApiUtils.validateImgUrl({ url: icon })}
                  alt="logo"
                  className="logo-org"
                />
              ) : (
                <div className="fs-18 text-white font-bold">{name}</div>
              )}
            </>
          ) : (
            <div className="mt-2" onClick={() => navigate(toPath)}>
              <img src={Assets.iconBackWhite} alt="Icon Arrow Left" />
            </div>
          )}
        </div>
        {isRight ? (
          <div
            className="top-right"
            onClick={() => navigate(PageRoutes.underDevelopment)}
          >
            <img src={Assets.iconNotification} alt="icon-notification" />
          </div>
        ) : (
          ''
        )}
      </div>
      <Slider {...settings}>
        {data &&
          data.map((item, index) => {
            return (
              <div key={index} className="img-container">
                <div
                  onClick={() => handleRedirect(item)}
                  style={{
                    background: `linear-gradient(45deg, rgba(0,0,0,0.42), rgba(0,0,0,0.42)), url(${ApiUtils.validateImgUrl(
                      {
                        url: item?.images?.img?.display,
                      }
                    )})`,
                    backgroundSize: 'cover',
                  }}
                  alt="placeholder"
                  className="w-100 banner-img"
                />
                {isBottom ? (
                  <div className="bottom-left">
                    <div>{item.title}</div>
                    <div>{ReactHtmlParser(readMore(item.description))}</div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            );
          })}
      </Slider>
      {isOpen ? (
        <ModalZoom
          handleClose={() => setIsOpen(!isOpen)}
          open={isOpen}
          data={data}
        ></ModalZoom>
      ) : (
        ''
      )}
    </div>
  );
};

export default BannerSlider;
